<script setup lang="ts">
import IconMagazine from '@/assets/icons/briefing.svg'

defineProps({
  iconGray: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <BaseBadge>
    <IconMagazine :class="{ 'text-s-500': iconGray }" />
  </BaseBadge>
</template>
